module.exports = __webpack_public_path__ + "img/reels.d76d02ca.svg";